import ApiCaller from 'actions/ApiCaller';
import baseConfig from 'actions/BaseAjaxConfig';
export var suggestionActionsEnum;
(function (suggestionActionsEnum) {
    suggestionActionsEnum["SUGGESTION_REQUEST"] = "SUGGESTION_REQUEST";
    suggestionActionsEnum["SUGGESTION_SUCCESS"] = "SUGGESTION_SUCCESS";
    suggestionActionsEnum["SUGGESTION_ERROR"] = "SUGGESTION_ERROR";
})(suggestionActionsEnum || (suggestionActionsEnum = {}));
export function fetchSuggestionResult(params) {
    const query = {
        query: params
    };
    return (dispatch) => {
        dispatch({
            type: suggestionActionsEnum.SUGGESTION_REQUEST
        });
        const pathname = `/api/1/self-serve/helpcenter/autosuggest`;
        return ApiCaller.get(Object.assign({}, baseConfig, {
            pathname,
            query,
            action: suggestionActionsEnum.SUGGESTION_REQUEST
        })).then(data => {
            return dispatch({
                type: suggestionActionsEnum.SUGGESTION_SUCCESS,
                data: data['RESPONSE']
            });
        });
    };
}
